import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const RolesPage = lazy(() => import('./pages/RolesPage'));
const AuditLogPage = lazy(() => import('./pages/AuditLogPage'));
const OrgSettingsPage = lazy(() => import('./pages/OrgSettingsPage'));
const UsersPage = lazy(() => import('./pages/UsersPage'));
const TeamsPage = lazy(() => import('./pages/TeamsPage'));
const BulkUserImportPage = lazy(() => import('./pages/BulkUserImportPage'));
const DataRetentionPage = lazy(() => import('./pages/DataRetentionPage'));
const BackupRestorePage = lazy(() => import('./pages/BackupRestorePage'));
const ModulesPlansPage = lazy(() => import('./pages/ModulesPlansPage'));

export const AdminRoutes: RouteObject = {
  path: 'admin',
  element: <ModuleGuard moduleId="core.admin" />,
  children: [
    { path: 'roles', element: <RolesPage />, handle: { crumb: 'Roles' } },
    { path: 'audit-log', element: <AuditLogPage />, handle: { crumb: 'Audit Log' } },
    { path: 'org-settings', element: <OrgSettingsPage />, handle: { crumb: 'Company Settings' } },
    { path: 'users', element: <UsersPage />, handle: { crumb: 'Users' } },
    { path: 'teams', element: <TeamsPage />, handle: { crumb: 'Teams' } },
    { path: 'bulk-user-import', element: <BulkUserImportPage />, handle: { crumb: 'Bulk User Import' } },
    { path: 'data-retention', element: <DataRetentionPage />, handle: { crumb: 'Data Retention' } },
    { path: 'backup-restore', element: <BackupRestorePage />, handle: { crumb: 'Backup Restore' } },
    { path: 'modules-plans', element: <ModulesPlansPage />, handle: { crumb: 'Modules Plans' } },
  ],
};
